import * as React from "react";
import { Switch } from "react-router-dom";
import FtPayOutCont from "../components/toc/fundTransfer/ftPayOutCont/ftPayOutCont";
import FtModalPayIn from "../components/toc/fundTransfer/ftModal/ftModalPayInStat";
import FtModalPayOut from "../components/toc/fundTransfer/ftModal/ftModalPayOutStat";
import FtHistoryCont from "../components/toc/fundTransfer/ftHistoryFundsContainer/ftHistoryCont";
import FtPayInCont from "../components/toc/fundTransfer/ftPayInCont/ftPayInCont";
import PostLogin from "./postLogin";

const FtRouting = () => {
	return (
		<>
			<Switch>
				<PostLogin path="/fund-transfer/add-funds" exact render={(props) => <FtPayInCont {...props} />} />
				<PostLogin path="/fund-transfer/withdraw-funds" exact render={(props) => <FtPayOutCont {...props} />} />
				<PostLogin path="/fund-transfer/withdraw-funds/:state" exact render={(props) => <FtModalPayOut {...props} />} />
				<PostLogin path="/fund-transfer/add-funds/:state" render={(props) => <FtModalPayIn {...props} />} />
				<PostLogin path="/fund-transfer/history/:asset/:funds" render={(props) => <FtHistoryCont {...props} />} />
			</Switch>
		</>
	);
};
export default FtRouting;
